import repository from '@/api'
import utils from '@/utils'
import FmsInstanceState from '@/enumerations/FmsInstanceState'

const URI = '/v1/fms-instances'
export default {
  registerFmsInstance({ workplaceId, projectCode }: FmsInstanceOfCreation, file?: File) {
    return repository.post(`${URI}`, file ? utils.buildFormData({ workplaceId, projectCode }, { file }) : { workplaceId, projectCode })
  },
  findFmsInstanceById(fmsInstanceId) {
    return repository.get(`${URI}/${fmsInstanceId}`)
  },
  modifyFmsInstance(fmsInstanceId, { state, subdomainForOccupantApp }: FmsInstanceOfModification) {
    return repository.patch(`${URI}/${fmsInstanceId}`, { state, subdomainForOccupantApp })
  },
  changeWorkplace(fmsInstanceId, { workplaceId, projectCode }) {
    return repository.post(`${URI}/${fmsInstanceId}/change-workplace`, { workplaceId, projectCode })
  },
  loadMigrationData(fmsInstanceId, file: File) {
    return repository.post(`${URI}/${fmsInstanceId}/load-migration-data`, utils.buildFormData({}, { file }))
  },
  removeFmsInstance(fmsInstanceId, { projectCode }) {
    return repository.delete(`${URI}/${fmsInstanceId}`, { projectCode })
  },
}

type FmsInstanceOfCreation = {
  workplaceId: string
  projectCode: string
}

type FmsInstanceOfModification = {
  state?: keyof typeof FmsInstanceState
  subdomainForOccupantApp?: string
}
